import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ContentAccessTypeItem } from 'src/types/ContentAccessTypeItem';
import { FilterGroup } from 'src/types/FilterGroup';
import { ResourceListItem } from 'src/types/ResourceListItem';

const {
	OpenAccessContentAccessTypeId,
	RegisteredUserContentAccessTypeId,
	RcnMemberContentAccessTypeId,
	RcniPlusSubscriberContentAccessTypeId,
	OrganisationalProductContentAccessTypeId,
	TypeOfAccessFilterId,
} = sitecoreIds.Items;

export type getAccessTypeStringProps = {
	item: ResourceListItem;
	filters?: FilterGroup[] | undefined;
	registeredUserText?: Field<string>;
	rcnMemberText?: Field<string>;
	rcniPlusSubscriberText?: Field<string>;
	organisationalProductText?: Field<string>;
	openAccessText?: Field<string>;
};

export function getAccessTypeString(props: getAccessTypeStringProps): { text: string; id?: string } {
	if (!props.item.AccessTypes || !props.filters) {
		return {
			text: '',
			id: '',
		};
	}

	const accessIds = Array.from(props.item.AccessTypes.values()).map((AccessType) => {
		const access = props.filters
			?.find((filter) => filter.id === TypeOfAccessFilterId)
			?.options?.find((accessOption) => accessOption.title.toLowerCase() === AccessType.toLowerCase());
		return access?.id;
	});

	return getTextValue({
		accessIds: accessIds,
		openAccessText: props.openAccessText,
		registeredUserText: props.registeredUserText,
		rcnMemberText: props.rcnMemberText,
		rcniPlusSubscriberText: props.rcniPlusSubscriberText,
		organisationalProductText: props.organisationalProductText,
	});
}

export type getAccessTypeStringContentProps = {
	accessType?: Array<ContentAccessTypeItem>;
	openAccessText?: Field<string> | undefined;
	registeredUserText?: Field<string> | undefined;
	rcnMemberText?: Field<string> | undefined;
	rcniPlusSubscriberText?: Field<string> | undefined;
	organisationalProductText?: Field<string> | undefined;
};

export function getAccessTypeStringContent(props: getAccessTypeStringContentProps): {
	text: string;
	id?: string;
} {
	if (!props.accessType) {
		return {
			text: '',
			id: '',
		};
	}

	const accessIds = props.accessType.map((accessTypes) => accessTypes.id);

	return getTextValue({
		accessIds: accessIds,
		openAccessText: props.openAccessText,
		registeredUserText: props.registeredUserText,
		rcnMemberText: props.rcnMemberText,
		rcniPlusSubscriberText: props.rcniPlusSubscriberText,
		organisationalProductText: props.organisationalProductText,
	});
}

type getTextValueProps = {
	accessIds: (string | undefined)[];
	openAccessText?: Field<string>;
	registeredUserText?: Field<string>;
	rcnMemberText?: Field<string>;
	rcniPlusSubscriberText?: Field<string>;
	organisationalProductText?: Field<string>;
};

export function getTextValue(props: getTextValueProps): { text: string; id?: string } {
	if (props.accessIds.includes(OpenAccessContentAccessTypeId)) {
		return {
			text: props.openAccessText?.value ?? '',
			id: OpenAccessContentAccessTypeId,
		};
	}

	if (props.accessIds.includes(RegisteredUserContentAccessTypeId)) {
		return {
			text: props.registeredUserText?.value ?? '',
			id: RegisteredUserContentAccessTypeId,
		};
	}
	if (props.accessIds.includes(RcnMemberContentAccessTypeId) && props.accessIds.includes(RcniPlusSubscriberContentAccessTypeId)) {
		return {
			text: (props.rcnMemberText?.value + ' - ' + props.rcniPlusSubscriberText?.value).replaceAll('only', '').trim(),
			id: RcnMemberContentAccessTypeId || RcniPlusSubscriberContentAccessTypeId,
		};
	}

	if (props.accessIds.includes(RcnMemberContentAccessTypeId)) {
		return {
			text: props.rcnMemberText?.value ?? '',
			id: RcnMemberContentAccessTypeId,
		};
	}

	if (props.accessIds.includes(RcniPlusSubscriberContentAccessTypeId)) {
		return {
			text: props.rcniPlusSubscriberText?.value ?? '',
			id: RcniPlusSubscriberContentAccessTypeId,
		};
	}

	if (props.accessIds.includes(OrganisationalProductContentAccessTypeId)) {
		return {
			text: props.organisationalProductText?.value ?? '',
			id: OrganisationalProductContentAccessTypeId,
		};
	}

	return {
		text: '',
		id: '',
	};
}
